<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :visible="visible"
    width="500px"
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <el-form ref="form" :model="formData" label-width="120px" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('tc_order_info_tcMode') || 'TC加价模式'">
            <el-radio-group v-model="formData.tcMode">
              <el-radio label="sub">{{
                $l('tc_order_info_tcMode_sub') || '降价率'
              }}</el-radio>
              <el-radio label="add">{{
                $l('tc_order_info_tcMode_add') || '加价率'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('tc_order_info_tcMarkupRate') || 'TC加价率百分比'"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              size="small"
              :min="0"
              :step="0.01"
              :precision="2"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.tcMarkupRate"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">{{
        this.$l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        this.$l('INDEX.btn_save') || '保存'
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
const initForm = { tcMarkupRate: 0, tcMode: 'sub' }
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { ...initForm },
    }
  },
  methods: {
    confirm() {
      const { tcMarkupRate, tcMode } = this.formData

      if (0 !== tcMarkupRate && !tcMarkupRate) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tc_order_info_select_tcMarkupRate') ||
            '请选择TC加价率百分比',
          type: 'warning',
        })
        return
      }

      if (tcMode === 'sub' && tcMarkupRate >= 100) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tc_order_info_select_tcMarkupRate') ||
            '减价率不能够为100%',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', { tcMarkupRate, tcMode, orderCode: this.orderCode })
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.formData = { ...initForm }
    },
  },
}
</script>
